import React, { useEffect } from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import { css } from "aphrodite";
import styles from "./styles";
import { notify } from "../../../../Utils";
import {useTranslation} from "react-i18next";

const RequestLayout = ({
    children,
    error,
    loading,
    overlayLoading = false,
}) => {
    const [t] = useTranslation(["translation"]);
    useEffect(() => {
        if (error) {
            notify(t("Error, please try again"), "error", 4000);
        }
    }, [error]);

    return (
        <>
            <>
                {loading && !overlayLoading ? (
                    <div
                        className={css(
                            styles.centerContainer,
                            styles.smallPadding
                        )}
                    >
                        <CircularProgress />
                    </div>
                ) : (
                    <>
                        {children}
                        <Backdrop
                            className={css(styles.backDrop)}
                            open={Boolean(loading && overlayLoading)}
                        >
                            <CircularProgress />
                        </Backdrop>
                    </>
                )}
            </>
        </>
    );
};

export default RequestLayout;
